import React from "react";
import SimplePage from "../../components/legal/SimplePage";
import { useCurrency } from "../../context/CurrencyContext";

export default function Careers() {
  const { settings } = useCurrency();
  return <SimplePage eyebrow="Company" title="Careers" text={settings?.content_careers} loading={!settings?.content_careers} />;
}
